export const attractionSteps = [
  {
    title: "Real-time Attraction",
    description:
      "Real-life triggers dopamine spike; context, movement, and novelty enhance appeal.",
    graphType: "real",
    graphColor: "cyan",
    trend: "rising",
    drive: "lust/dopamine",
    graphInfo:
      "Real: dynamic cues like movement and novelty trigger immediate attraction.",
  },
  {
    title: "Photo Perception Drop",
    description:
      "Static photos remove dynamic cues; prefrontal evaluation overrides instinct, lowering attraction.",
    graphType: "photo",
    graphColor: "gold",
    trend: "falling",
    drive: "judgment",
    graphInfo:
      "Photo: static cues remove novelty; prefrontal evaluation lowers instinctive attraction.",
  },
  {
    title: "Memory vs Reality",
    description:
      "Brain reconstructs idealized memory; static images rarely match real-time perception.",
    graphType: "photo",
    graphColor: "magenta",
    trend: "falling",
    drive: "nostalgia/idealization",
    graphInfo:
      "Photo: memory reconstruction may idealize or distort real perception.",
  },
  {
    title: "Porn Comparison",
    description:
      "Pornography is curated and edited, creating distorted standards compared to real people on the street.",
    graphType: "photo",
    graphColor: "orange",
    trend: "falling",
    drive: "greed/curiosity",
    graphInfo:
      "Photo: curated and edited content sets unrealistic baseline for attraction.",
  },
  {
    title: "Instant Physical Boost",
    description:
      "Initial spike occurs due to novelty and dopamine; it doesn't require conscious identification.",
    graphType: "real",
    graphColor: "lime",
    trend: "rising",
    drive: "lust/novelty",
    graphInfo:
      "Real: novelty and dopamine spikes cause immediate physical attraction.",
  },
  {
    title: "Emotional vs Cognitive Alignment",
    description:
      "Cognition evaluates rationally; emotion lags, creating the paradox between impulse and judgment.",
    graphType: "real",
    graphColor: "lightblue",
    trend: "rising",
    drive: "reflection/emotion",
    graphInfo:
      "Real: emotional response lags cognitive evaluation, creating paradox.",
  },
  {
    title: "Channeling Inner Energy",
    description:
      "Observe attraction without over-identifying; shift focus to inner energy or intention.",
    graphType: "real",
    graphColor: "purple",
    trend: "stable",
    drive: "conscious attention",
    graphInfo:
      "Real: focus shifts to internal energy rather than external cues.",
  },
  {
    title: "Detailed Reflection",
    description:
      "Analyze why certain stimuli trigger spikes. Understand patterns, context, and media influence.",
    graphType: "photo",
    graphColor: "pink",
    trend: "falling",
    drive: "analysis/judgment",
    graphInfo: "Photo: analytical observation reduces instinctive attraction.",
  },
  {
    title: "Personal Growth Takeaway",
    description:
      "Use observation as a tool for self-regulation; channel attention consciously rather than reactively.",
    graphType: "real",
    graphColor: "limegreen",
    trend: "stable", // changed from rising
    drive: "self-control/clarity",
    graphInfo: "Real: conscious attention channels attraction positively.",
  },
];
